var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 158,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "60.738%",
    x2: "27.149%",
    y1: "4.962%",
    y2: "71.9%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".66%",
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "26.01%",
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51.22%",
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.04%",
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "107.583%",
    x2: "-130.478%",
    y1: "49.994%",
    y2: "49.994%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.87%",
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77.54%",
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "86.252%",
    x2: "-50.14%",
    y1: "30.368%",
    y2: "138.379%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "-18.81%",
    x2: "42.093%",
    y1: "-13.572%",
    y2: "34.659%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "6.85%",
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.62%",
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80.09%",
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M20.074 0h117.852c6.608 0 9.281.743 11.889 2.137a14.538 14.538 0 0 1 6.048 6.048c1.394 2.608 2.137 5.281 2.137 11.889v7.852c0 6.608-.743 9.281-2.137 11.889a14.538 14.538 0 0 1-6.048 6.048C147.207 47.257 144.534 48 137.926 48H20.074c-6.608 0-9.281-.743-11.889-2.137a14.538 14.538 0 0 1-6.048-6.048C.743 37.207 0 34.534 0 27.926v-7.852c0-6.608.743-9.281 2.137-11.889a14.538 14.538 0 0 1 6.048-6.048C10.793.743 13.466 0 20.074 0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M79.261 26.412c-2.557 0-4.643 1.972-4.643 4.689 0 2.7 2.085 4.69 4.643 4.69 2.56 0 4.645-1.99 4.645-4.69 0-2.717-2.086-4.69-4.645-4.69Zm0 7.533c-1.402 0-2.61-1.173-2.61-2.843 0-1.688 1.21-2.842 2.61-2.842 1.403 0 2.61 1.154 2.61 2.842 0 1.67-1.207 2.843-2.61 2.843Zm-10.13-7.534c-2.558 0-4.643 1.972-4.643 4.69 0 2.7 2.085 4.688 4.644 4.688 2.558 0 4.643-1.989 4.643-4.689 0-2.717-2.085-4.69-4.643-4.69h-.001Zm0 7.533c-1.402 0-2.61-1.173-2.61-2.843 0-1.688 1.21-2.842 2.61-2.842 1.402 0 2.61 1.154 2.61 2.842.002 1.67-1.208 2.843-2.61 2.843ZM57.082 27.85v1.989h4.696c-.14 1.119-.507 1.936-1.07 2.504-.682.692-1.75 1.456-3.626 1.456-2.891 0-5.15-2.363-5.15-5.293s2.259-5.294 5.15-5.294c1.56 0 2.698.622 3.54 1.422l1.384-1.403c-1.175-1.138-2.733-2.007-4.924-2.007-3.96 0-7.29 3.267-7.29 7.281 0 4.015 3.33 7.283 7.29 7.283 2.137 0 3.75-.71 5.01-2.043 1.297-1.314 1.701-3.162 1.701-4.653 0-.462-.034-.888-.106-1.243h-6.605v.001Zm49.28 1.544c-.385-1.048-1.56-2.984-3.96-2.984-2.383 0-4.364 1.902-4.364 4.69 0 2.627 1.964 4.688 4.591 4.688 2.12 0 3.347-1.313 3.856-2.078l-1.577-1.066c-.526.781-1.245 1.296-2.279 1.296-1.033 0-1.77-.48-2.242-1.42l6.185-2.594-.21-.531v-.001Zm-6.309 1.564c-.051-1.813 1.385-2.736 2.42-2.736.805 0 1.489.41 1.717.995l-4.137 1.74Zm-5.028 4.547h2.032V21.723h-2.032v13.783Zm-3.33-8.046h-.07c-.455-.551-1.332-1.05-2.435-1.05-2.313 0-4.433 2.062-4.433 4.708 0 2.629 2.12 4.672 4.432 4.672 1.105 0 1.98-.497 2.437-1.065h.07v.675c0 1.793-.947 2.752-2.471 2.752-1.245 0-2.015-.905-2.33-1.668l-1.771.746c.508 1.242 1.857 2.77 4.1 2.77 2.384 0 4.4-1.42 4.4-4.885v-8.419h-1.928v.764Zm-2.33 6.485c-1.403 0-2.577-1.191-2.577-2.826 0-1.652 1.174-2.86 2.576-2.86 1.383 0 2.47 1.208 2.47 2.86 0 1.635-1.087 2.826-2.47 2.826h.001Zm26.517-12.22h-4.862v13.781h2.028v-5.22h2.833c2.25 0 4.462-1.652 4.462-4.281 0-2.629-2.211-4.282-4.46-4.282v.001Zm.053 6.642h-2.887v-4.724h2.887c1.517 0 2.378 1.273 2.378 2.363 0 1.066-.86 2.36-2.378 2.36Zm12.543-1.98c-1.47 0-2.992.657-3.621 2.111l1.801.762c.385-.763 1.103-1.01 1.855-1.01 1.05 0 2.116.637 2.134 1.772v.142c-.368-.213-1.155-.531-2.117-.531-1.941 0-3.92 1.081-3.92 3.102 0 1.844 1.593 3.031 3.377 3.031 1.364 0 2.117-.62 2.589-1.347h.07v1.063h1.96v-5.284c0-2.446-1.803-3.81-4.128-3.81Zm-.246 7.554c-.664 0-1.592-.337-1.592-1.17 0-1.065 1.156-1.472 2.153-1.472.891 0 1.312.194 1.854.46a2.472 2.472 0 0 1-2.415 2.182Zm11.511-7.252-2.327 5.976h-.07l-2.414-5.976h-2.186l3.62 8.352-2.064 4.645h2.116L142 26.689h-2.257Zm-18.28 8.817h2.03v-13.78h-2.03v13.78ZM56.729 13.724c0 .924-.27 1.659-.81 2.208-.614.653-1.415.98-2.398.98-.943 0-1.744-.331-2.402-.992-.659-.664-.988-1.483-.988-2.463s.33-1.8.988-2.462c.658-.661 1.46-.992 2.402-.992.468 0 .915.092 1.339.275.426.186.766.432 1.02.74l-.573.582c-.432-.524-1.026-.785-1.787-.785-.688 0-1.282.244-1.783.734-.501.49-.752 1.125-.752 1.907 0 .781.251 1.418.752 1.908a2.467 2.467 0 0 0 1.783.734c.729 0 1.337-.246 1.823-.739.315-.321.498-.767.547-1.34h-2.37v-.794h3.162c.032.173.047.34.047.499Zm5.014-2.763H58.77v2.098h2.679v.794h-2.68v2.097h2.972v.814h-3.81v-6.615h3.81v.812Zm3.536 5.803h-.839V10.96h-1.822v-.812H67.1v.812h-1.822v5.803Zm5.067 0v-6.615h.839v6.615h-.839Zm4.558 0h-.839V10.96h-1.822v-.812h4.483v.812h-1.822v5.803Zm10.31-.855c-.64.668-1.438 1.002-2.392 1.002s-1.75-.334-2.391-1.002c-.642-.668-.96-1.486-.96-2.453 0-.967.318-1.785.96-2.453.64-.668 1.437-1.003 2.392-1.003.948 0 1.745.336 2.388 1.008.644.67.966 1.486.966 2.448 0 .967-.32 1.785-.961 2.453h-.001Zm-4.164-.555a2.377 2.377 0 0 0 1.773.744 2.38 2.38 0 0 0 1.773-.744c.483-.496.725-1.129.725-1.898 0-.77-.242-1.403-.725-1.899a2.376 2.376 0 0 0-1.773-.742c-.7 0-1.29.248-1.773.742-.482.496-.725 1.13-.725 1.9 0 .768.243 1.401.725 1.897Zm6.304 1.41v-6.615h1.02l3.172 5.145h.036l-.036-1.274v-3.871h.838v6.615h-.875l-3.319-5.396h-.036l.036 1.274v4.122h-.836Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M.503.438C.186.778 0 1.305 0 1.988v24.381c0 .684.187 1.21.503 1.55l.08.078L14.06 14.338v-.321L.584.357.503.439Z",
    transform: "translate(16 10.304)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M18.55 18.894 14.06 14.34v-.322l4.492-4.554.1.059 5.323 3.065c1.52.876 1.52 2.307 0 3.183l-5.322 3.065-.102.058Z",
    transform: "translate(16 10.304)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m18.652 18.836-4.594-4.658L.503 27.92c.5.539 1.328.605 2.26.07l15.89-9.153h-.001Z",
    transform: "translate(16 10.304)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M18.652 9.522 2.762.372C1.833-.167 1.006-.1.505.438L14.06 14.18l4.593-4.658h-.001Z",
    transform: "translate(16 10.304)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.c68fc9a2c4113df4340a43f2b5763410.svg";
export { ForwardRef as ReactComponent };